import {HTHSymbol, HTHSymbolStates, ISymbolData} from "./HTHSymbol";
import {HTHGameConfig} from "../HTHGameConfig";
import {gsap} from "gsap";
import {HTH} from "../HTH";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {HTHGameAssets} from "../HTHGameAssets";
import {HTHHelper} from "../utils/HTHHelper";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {HTHSound} from "../sound/HTHSound";

export class HTHXNudgeSymbol extends HTHSymbol {
    private _nudgeCounter: number = 1;
    private _multiplierContainer: PIXI.Container;
    private _multiplierCountup: PIXI.BitmapText;
    private _multiplierX: PIXI.BitmapText;
    private _spine: PIXI.spine.Spine;
    private _nudgedSymIds: number[];


    constructor(symbolData: ISymbolData, state: HTHSymbolStates) {
        super(symbolData);
        this.getStateAnimation(state);
        this.createCountupText();
        this.positionXNudgeAtSymId();
        this._participatedInWin = false;

        this._nudgedSymIds = [];
        this._isPartOfWin = false;
        HTH.model.gameData?.betWayWins.forEach((oneSymWin: IBetWayWinData, index: number) => {
            if (oneSymWin.reelWinPositions[this.reelId].includes(true)) {
                this._isPartOfWin = true;
            }
        })

    }

    private _isPartOfWin: boolean;

    get isPartOfWin(): boolean {
        return this._isPartOfWin;
    }

    private _participatedInWin: boolean;

    get participatedInWin(): boolean {
        return this._participatedInWin;
    }

    set participatedInWin(value: boolean) {
        this._participatedInWin = value;
    }

    public positionXNudgeAtSymId(): void {
        this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("XN"));
        this.addChild(this._spine);
        if (this.reelId > 0 && this.reelId < 5 && this.id === 3) {
            this._spine.position.y += 1;
        }
        HTHHelper.playSpineWithTimeline(this._spine, 0, "idle").pause(0.001, false);

    }

    public animationChange(animName: string): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(HTHHelper.playSpineWithTimeline(this._spine, 0, animName))
        return tl;
    }

    public revealXNudgeSize(symNudgedOverId: number, symNudgedOverSymSize: number): gsap.core.Timeline {
        const expansionTl: gsap.core.Timeline = gsap.timeline();
        this._nudgeCounter++;
        this._nudgedSymIds.push(symNudgedOverId);
        expansionTl.add(() => {
            this._multiplierContainer.visible = true;
        }, 0);
        if (this.symSize === 0) {
            this.symSize = 1;
        }
        if (symNudgedOverSymSize === 0) {
            symNudgedOverSymSize = 1;
        }
        if (symNudgedOverId <= this.id) {
            expansionTl.add(this.updateXNudgeMultiplier(this.symSize + symNudgedOverSymSize));
        } else if (symNudgedOverId > this.id) {
            expansionTl.to(this._multiplierContainer.position, {
                x: 0,
                y: symNudgedOverId * HTHGameConfig.symbolHeight,
                duration: 0.166
            })
            expansionTl.add(this.updateXNudgeMultiplier(this.symSize + symNudgedOverSymSize), "<");
        }
        return expansionTl;
    }

    public removeAndDestroy(): void {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }

    public playXNudgeAnim(XNSymId: number, isEnhancerOpen: boolean, isRestore: boolean = false): gsap.core.Timeline {
        const animTl: gsap.core.Timeline = gsap.timeline();
        if (this.reelId > 0 && this.reelId < 5 && this.id === 3) {
            this._spine.position.y -= 1;
        }
        if (isRestore) {
            if (isEnhancerOpen) {
                this._nudgedSymIds.push(1, 2, 3);
            } else {
                this._nudgedSymIds.push(1, 2);
            }
            this._spine.position.set(0, isEnhancerOpen ? 225 - this.id * 150 : (1 - this.id) * 150);
            if (this.id === 3 && this.reelId > 0 && this.reelId < 5) {
                this._spine.position.set(0, 225);
            }
            this.addChild(this._multiplierContainer);
            this._multiplierContainer.position.y = isEnhancerOpen ? 450 - this.y : 300 - this.y;
            return animTl.add(() => {
                this._spine.autoUpdate = true;
                this._spine.state.setAnimation(0, isEnhancerOpen ? "4Xnscenarioloop" : "3Xnscenarioloop", true);
            });
        }
        const shakeTl: gsap.core.Timeline = gsap.timeline();
        if (this.isPartOfWin) {
            for (let i = 1; i < (isEnhancerOpen ? 4 : 3); i++) {
                shakeTl.add(HTH.gameViewContainer.shakeEffect(0.06, 20, true, 30), i === 1 ? 0.166 : (0.166 + (0.27 * (i - 1))));
                shakeTl.add(() => {
                    HTHSound.playTrack(HTHSound.XN_NUDGE)
                }, i === 1 ? 0 : (0.166 + 0.06 * (i - 1) + (0.18 * (i - 2))))
            }
        }
        animTl.add(shakeTl, 0);
        animTl.add(() => {
            HTH.reelArea.allReels[this.reelId].reelView.reelLayers.maskedEffectsLayer.addChild(this._multiplierContainer);
            this._multiplierContainer.position.set(0, (this.id) * HTHGameConfig.symbolHeight);
        }, 0);
        if (!isRestore) {
            let animName: string = (isEnhancerOpen ? "4Xnscenario" : "3Xnscenario") + (XNSymId + 1);
            if (this.isPartOfWin) {
                animName += "_win";
            }
            animTl.add(HTHHelper.playSpineWithTimeline(this._spine, 0, animName), 0);
        }
        animTl.add(() => {
            this._spine.position.set(0, isEnhancerOpen ? (225 - this.id * 150) : ((1 - this.id) * 150) - 5);
        }, ">");

        if (this.isPartOfWin) {
            animTl.add(() => {
                this._spine.autoUpdate = true;
                this._spine.state.setAnimation(0, isEnhancerOpen ? "4Xnscenarioloop_nobiker" : "3Xnscenarioloop_nobiker", true);
            }, ">")
        } else {
            animTl.add(() => {
                this._spine.autoUpdate = true;
                this._spine.state.setAnimation(0, isEnhancerOpen ? "4Xnscenarioloop" : "3Xnscenarioloop", true);
            }, ">")
        }

        return animTl;
    }

    public playBikerAnim(XNSymId: number, isEnhancerOpen: boolean): gsap.core.Timeline {
        const animTl: gsap.core.Timeline = gsap.timeline();
        // animTl.add(() => {
        //     this._spine.position.set(0, isEnhancerOpen ? (225 - this.id * 150) : ((1 - this.id) * 150) - 5);
        // }, ">");

        animTl.add(() => {
                this._spine.state.setAnimation(0, (isEnhancerOpen ? "4Xnbikerintro" : "3Xnbikerintro"), false);
            }
            , 0);
        animTl.to(this, {duration: 1.2});
        animTl.add(() => {
            this._spine.state.setAnimation(0, isEnhancerOpen ? "4Xnscenarioloop" : "3Xnscenarioloop", true);
        }, ">")
        return animTl;

    }

    public moveMultiplierLayerUp() {
        HTH.reelArea.allReels[this.reelId].reelView.reelLayers.maskedEffectsLayer.addChild(this._multiplierContainer);
        this._multiplierContainer.position.set(0, (this.id) * HTHGameConfig.symbolHeight);
    }

    public moveMultiplierLayerDown(isEnhancerOpen: boolean): void {
        this.addChild(this._multiplierContainer);
        this._multiplierContainer.position.y = isEnhancerOpen ? 450 - this.y : 300 - this.y;
    }

    public moveUpLayer(): void {
        if (this && this.parent) {
            this.parent.removeChild(this);
            HTH.reelArea.allReels[this.reelId].reelView.reelLayers.fullWildSymbols.addChild(this);
        }
    }

    public resetSpinePosition(id: number, symName: string): void {
        // this._spine.position.set(0,(1-id)*150);
        if (symName === "EB") {
            this._multiplierContainer.position.set(-10, 450);
        } else if (symName === "SA") {
            // this._spine.position.set(0,-150);
            this._multiplierContainer.position.set(-10, 0);
        }
    }

    public addSplitEffect(size: number): gsap.core.Timeline {
        const splitTl: gsap.core.Timeline = gsap.timeline();
        splitTl.add(this.updateXNudgeMultiplier(size * 2))
        return splitTl;
    }

    public splitMultiplier(): gsap.core.Timeline {
        return this.addSplitEffect(this.symSize);
    }

    public updateXNudgeMultiplier(value: number): gsap.core.Timeline {
        const mulTl: gsap.core.Timeline = gsap.timeline();


        // mulTl.to(this._multiplierContainer.scale, {duration: 0.01, x: 0.8, y: 0.8});

        const miniTl: gsap.core.Timeline = gsap.timeline();
        let currentValue: number = JSON.parse(JSON.stringify(this.symSize));
        const countIncrease: number = value - currentValue;

        for (let i: number = 1; i <= countIncrease; i++) {
            const singleUpdate: gsap.core.Timeline = gsap.timeline();
            const durr: number = 0.14 / countIncrease;
            let scale: number = JSON.parse(JSON.stringify(this._multiplierContainer.scale.x));
            singleUpdate.to(this, {duration: durr});
            singleUpdate.add(() => {
                scale = JSON.parse(JSON.stringify(this._multiplierContainer.scale.x));
            }, 0);
            if (i === countIncrease) {
                singleUpdate.to(this._multiplierContainer.scale, {
                    x: scale + 0.4,
                    y: scale + 0.4,
                    duration: durr / 2
                }, 0);
            }
            singleUpdate.add(() => {
                this._multiplierCountup.text = (currentValue + i).toString();
            }, ">");
            if (i === countIncrease) {
                singleUpdate.to(this._multiplierContainer.scale, {x: scale, y: scale, duration: durr / 2}, durr / 2);
            }
            this.symSize += 1;
            singleUpdate.add(() => {
                this.adjustMultiPosition();
            })
            miniTl.add(singleUpdate);
        }

        mulTl.add(miniTl);

        mulTl.add(() => {
            this.symSize = value;
            this.adjustMultiPosition();
        }, ">");
        if (HTH.model.isRestore) {
            mulTl.add(() => {
                this._multiplierCountup.text = HTH.model.data.xNudgeMultipliers[this.reelId].toString();
                this.adjustMultiPosition();
            })
        }
        return mulTl;
    }

    public updatexNudgeMultiplierForRestore(isRestore: boolean) {
        this.addChild(this._multiplierContainer);
        this._multiplierContainer.visible = true
        this._multiplierCountup.text = HTH.model.data.xNudgeMultipliers[this.reelId].toString();
        this.symSize = HTH.model.data.xNudgeMultipliers[this.reelId];
        if (!isRestore) {
            this._multiplierCountup.text = "4";
        }
        this._multiplierContainer.pivot.set(0, this._multiplierContainer.height / 2);
        this.adjustMultiPosition();

    }

    public highlight(): gsap.core.Timeline {
        const highlightTl: gsap.core.Timeline = gsap.timeline();
        this._nudgedSymIds.forEach((item: number) => {
            highlightTl.add(this.createWinHighlightEffect((item - this.id) * HTHGameConfig.symbolHeight), 0);
        });
        highlightTl.add(this.createWinHighlightEffect(0), 0);
        return highlightTl;
    }

    public explode(): gsap.core.Timeline {
        const explodeTl: gsap.core.Timeline = gsap.timeline();
        this._nudgedSymIds.forEach((item: number) => {
            explodeTl.add(this.createWinExplode((item - this.id) * HTHGameConfig.symbolHeight), 0);
        });
        HTH.model.xNudgePositionPerReel[this.reelId] = [];
        explodeTl.add(this.createWinExplode(0), 0);
        explodeTl.add(() => {
            if (this && this.parent) {
                if (!this.isEnhancerSymbol && this.symName !== "RW") {
                    this.removeAndDestroy();
                }
            }
            HTH.reelArea.allReels[this.reelId].reelView.isStacked = false;
        });
        return explodeTl;
    }

    private createCountupText(): void {
        this._multiplierContainer = new PIXI.Container();
        this._multiplierX = new PIXI.BitmapText("x", {
            fontName: HTHGameAssets.BITMAP_FONT_XNUDGE_MULTIPLIER,
            fontSize: 16
        });
        this._multiplierCountup = new PIXI.BitmapText(`${this.symSize === 0 ? 1 : this.symSize}`, {
            fontName: HTHGameAssets.BITMAP_FONT_XNUDGE_MULTIPLIER,
            fontSize: 16
        });


        this._multiplierCountup.position.set(0, 0);
        this._multiplierX.position.set(0, 0);
        this._multiplierCountup.name = "xNudgeMultiplier";
        this._multiplierContainer.addChild(this._multiplierX, this._multiplierCountup);
        this._multiplierContainer.position.set(0, 0);
        this._multiplierContainer.name = "xnudgeMultiContainer";
        this._multiplierContainer.pivot.set(0, this._multiplierContainer.height / 2);
        this.adjustMultiPosition();

        this._multiplierContainer.visible = true;
        this.addChild(this._multiplierContainer);

    }

    private createWinHighlightEffect(heightPos: number): gsap.core.Timeline {
        const highlightTl: gsap.core.Timeline = gsap.timeline();
        const winHighlightAnim: TimelineSprite = this.getWinHighlightAnim();
        winHighlightAnim.position.set(0, heightPos);
        highlightTl.add(<gsap.core.Timeline><unknown>winHighlightAnim.getAnimationAutoShowHide(), "<");
        highlightTl.add(() => {
            winHighlightAnim.destroy();
        });
        return highlightTl;
    }

    private createWinExplode(heightPos: number): gsap.core.Timeline {
        const winEffectTl: gsap.core.Timeline = gsap.timeline();
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("blast"));
        this.addChild(spine);
        spine.position.set(0, heightPos);
        winEffectTl.add(HTHHelper.playSpineWithTimeline(spine, 0, "blast"));

        if (!this.isEnhancerSymbol && this.symName !== "RW") {
            winEffectTl.to([this._spine, this._multiplierContainer], {alpha: 0, duration: 0.533}, "<");
        }
        return winEffectTl;
    }

    private adjustMultiPosition(): void {
        this._multiplierCountup.position.set(this._multiplierX.width, 0);
        const contWidth: number = this._multiplierX.width + this._multiplierCountup.width;
        this._multiplierContainer.pivot.set(contWidth / 2, this._multiplierContainer.height / 2);
        if (contWidth > 100) {
            const scale: number = 100 / contWidth;
            this._multiplierContainer.scale.set(scale);
        }
    }
}